import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaPhoneAlt, FaTimes } from "react-icons/fa";
import logo from "../assets/logo.png";

export default function Header() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      //   window.gtag("config", "AW-18343552397/rJAbCNm_2NYcEI3L8apE", {
      //     phone_conversion_number: "1-877-991-0909",
      //   });
    }
  }, []);

  const handleCallConversion = () => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-18343552397/rJAbCNm_2NYcEI3L8apE",
      });
    }
  };

  const navItems = [
    { name: "Home", path: "/" },
    // { name: "Airlines", path: "/flights" },
    // { name: "Car Rental", path: "/cars" }, // Add this line
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
    { name: "FAQ", path: "/faq" },
  ];

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/95 font-sans text-slate-950 shadow-[0_10px_30px_rgba(15,23,42,0.05)] backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid min-h-[66px] grid-cols-[auto_1fr_auto] items-center  md:min-h-[76px]">
          <NavLink
            to="/"
            className="inline-flex max-w-[154px] items-center sm:max-w-[184px]"
          >
            <img
              src={logo}
              alt="CheapOflyHub"
              className="h-auto w-full object-contain"
            />
          </NavLink>

          <nav className="hidden justify-center lg:flex">
            <div className="flex items-center gap-1 rounded-full border border-slate-200 bg-[#f6f9fc] p-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.path}
                  className={({ isActive }) =>
                    `rounded-full px-5 py-2.5 text-sm font-bold transition-all duration-200 ${
                      isActive
                        ? "bg-white text-[#155bc2] shadow-sm ring-1 ring-slate-200"
                        : "text-slate-600 hover:bg-white hover:text-slate-950"
                    }`
                  }
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
          </nav>

          <div className="flex justify-end">
            <a
              href="tel:+18779910909"
              onClick={handleCallConversion}
              className="hidden items-center gap-3 rounded-full bg-[#155bc2] px-6 py-3 text-sm font-extrabold text-white shadow-lg shadow-blue-600/20 transition hover:-translate-y-0.5 hover:bg-[#0f4ba8] hover:shadow-blue-600/30 active:translate-y-0 lg:flex"
            >
              <FaPhoneAlt className="text-xs" />
              <span>1-877-991-0909</span>
            </a>

            <div className="flex items-center gap-2 lg:hidden">
              <a
                href="tel:+18779910909"
                onClick={handleCallConversion}
                className="rounded-full border border-blue-100 bg-blue-50 px-4 py-2 text-sm font-extrabold text-[#155bc2]"
              >
                Call us
              </a>
              <button
                type="button"
                onClick={() => setOpen((value) => !value)}
                aria-label="Toggle navigation"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-950 shadow-sm transition hover:border-blue-200 hover:text-[#155bc2]"
              >
                {open ? <FaTimes /> : <FaBars />}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`overflow-hidden border-slate-200 bg-white transition-all duration-300 lg:hidden ${
          open ? "max-h-96 border-t" : "max-h-0"
        }`}
      >
        <div className="space-y-2 px-4 py-4">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block rounded-2xl px-5 py-3 text-sm font-bold transition ${
                  isActive
                    ? "bg-blue-50 text-[#155bc2]"
                    : "text-slate-600 hover:bg-[#f8f9fc] hover:text-slate-950"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </div>
      </div>
    </header>
  );
}
